import { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase"; // Import your Firestore instance

const useUpdateProduct = () => {
  const [isPending, setIsPending] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  /**
   * Updates a product's fields in a specific list in Firestore.
   * @param {string} listId The ID of the list the product belongs to.
   * @param {string} productId The ID of the product to update.
   * @param {object} updates An object containing the fields to update (e.g., { name: "New Name", checked: true }).
   */
  const updateProduct = async (listId, productId, updates) => {
    setIsPending(true);
    setIsError(false);
    setIsSuccess(false);

    try {
      if (!listId || !productId) {
        throw new Error(
          "Both listId and productId are required to update a product."
        );
      }
      if (
        !updates ||
        typeof updates !== "object" ||
        Object.keys(updates).length === 0
      ) {
        throw new Error(
          "Updates object must be provided and contain at least one field."
        );
      }

      const productRef = doc(db, "lists", listId, "products", productId);
      await updateDoc(productRef, updates);

      setIsSuccess(true);
      console.log(
        `Product ${productId} in list ${listId} updated successfully.`
      );
    } catch (error) {
      setIsError(true);
      console.error("Error updating product:", error);
      throw error; // Re-throw to allow component to catch if needed
    } finally {
      setIsPending(false);
    }
  };

  // Reset status flags
  const resetStatus = () => {
    setIsPending(false);
    setIsError(false);
    setIsSuccess(false);
  };

  return { updateProduct, isPending, isError, isSuccess, resetStatus };
};

export default useUpdateProduct;
